<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model.trim="bseqid"
        clearable
        placeholder="请输入票据单号"
        class="filter-item"
        @keyup.enter.native="getList"
        style="margin-right: 10px;width: 200px;"
      >
      </el-input>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      ref="dataTable"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      :max-height="clientHeight"
      size="mini"
    >
      <el-table-column align="center" label="流水号" width="100">
        <template slot-scope="scope">{{ scope.row.bseqid }}</template>
      </el-table-column>
      <el-table-column align="center" label="品种编码" width="100">
        <template slot-scope="scope">{{ scope.row.artid }}</template>
      </el-table-column>
      <el-table-column label="品名" align="center" min-width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="规格" align="center" width="150" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.spec }}</template>
      </el-table-column>
      <el-table-column label="单位" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.unit }}</template>
      </el-table-column>
      <el-table-column label="产家" align="center" min-width="250" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.factory }}</template>
      </el-table-column>
      <el-table-column label="有效期" align="center" width="100">
        <template slot-scope="scope">{{ scope.row.expiry }}</template>
      </el-table-column>
      <el-table-column
        label="批号"
        align="center"
        width="150"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">{{ scope.row.serial }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary">
            <i class="el-icon-download"></i>
            <a :href="scope.row.docaddr">下载报告单</a>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--&lt;!&ndash;分页&ndash;&gt;-->
    <!--<pagination-->
    <!--:total="total"-->
    <!--:page.sync="listQuery.page"-->
    <!--:limit.sync="listQuery.limit"-->
    <!--@pagination="getList"-->
    <!--&gt;-->
    <!--</pagination>-->
  </div>
</template>

<script>
import { getProductInfo } from '@/api/flow'
// import Pagination from '@/components/Pagination'

export default {
  name: 'ProductInfo',

  // components: {
  //   Pagination
  // },

  data() {
    return {
      clientHeight: '800',
      list: null,
      bseqid: '',
      listLoading: false
    }
  },

  created() {
    this.initHeight()
  },

  mounted() {
    window.addEventListener('resize', this.initHeight)
  },

  methods: {
    initHeight() {
      this.clientHeight = document.documentElement.clientHeight - 240
    },

    getList() {
      this.list = []
      if (this.bseqid !== '') {
        this.listLoading = true
        getProductInfo(this.bseqid)
          .then(response => {
            this.list = response.data
            this.listLoading = false
          })
          .catch(() => {
            this.list = []
            this.listLoading = false
          })
      }
    }
  }
}
</script>
